import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Text,
  useToast,
  VStack
} from '@chakra-ui/react';
import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BiTransferAlt } from 'react-icons/bi';
import { CgPassword } from 'react-icons/cg';
import { FaEye, FaEyeSlash, FaUserFriends } from 'react-icons/fa';
import { MdMail } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';

import { api } from '../../api/baseApi';
import { actionSignIn, actionSignUp } from '../../api/postApi';
import { COMMON_WEB_PATH } from '../../constant';
import useGetAgentName from '../../hook/useGetAgentName';
import useInviteCode from '../../hook/useInviteCode';
import useTransCode from '../../hook/useTransCode';
import { notice } from '../../redux/action/action';
import {
  accountExpressForInput,
  passwordExpressForInput
} from '../../regex_constanst';
import GetParams from '../../utils/getParams';
import i18next from 'i18next';

const iconStyle = 'text-gray-300';

const SignupForm = () => {
  const { t } = useTranslation();
  const i18n = (key, props) => t(`header.${key}`, { ...props });
  const i18n_common = (key) => t(`common.${key}`);
  const i18n_common_form = (key) => t(`settings.form.${key}`);
  const i18n_formHint = (key, props) => t(`formHint.${key}`, { ...props });
  const i18n_backend_response = (key) => t(`backend_response.${key}`);

  const toast = useToast();

  const [searchParams, setSearchParams] = useSearchParams();

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const agent_name = useGetAgentName();

  const [formData, setFormData] = useState({
    user_name: '',
    password: '',
    real_name: '',
    mobile: '',
    email: '',
    verifiedCode: '',
    code: ''
  });
  const [buttonLoading, setButtonLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [emailLoading, setEmailLoading] = useState(false);
  const [emailSendStatus, setEmailSendStatus] = useState(false);
  const [seconds, setSeconds] = useState(0);

  const trans_code = useTransCode();
  const invite_code = useInviteCode();

  const { user_name, password, real_name, mobile, email, code } = formData;

  const unlimit_code = GetParams('uac');
  const invite = Cookies.get('invite');

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSeePassword = () => {
    setShowPassword(!showPassword);
  };

  const handleVerifyEmail = async () => {
    setEmailLoading(true);
    await api
      .post('/getCode', {
        email: email
      })
      .then((data) => {
        setSeconds(60);
        setEmailSendStatus(true);
        dispatch(
          notice({
            title: data?.message,
            type: 'success'
          })
        );
      })
      .finally(() => {
        setEmailLoading(false);
      });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // const open_registration = window?.open_registration == 1;
    // if (!open_registration) {
    //   dispatch(
    //     notice({
    //       title: i18n("registration_closed"),
    //       type: "error",
    //     })
    //   );
    //   return;
    // }

    setButtonLoading(true);

    await actionSignUp({
      memId: user_name,
      passwd: password,
      true_name: real_name,
      mobile: mobile,
      email: email,
      unlimit_code: unlimit_code,
      invite: invite || invite_code,
      code: code
    })
      .then((data) => {
        Cookies.remove('token');
        toast({
          title: i18n_backend_response('Sign up success'),
          description: 'We will login for you now, please wait a moment.',
          status: 'success',
          duration: 1500,
          isClosable: true
        });
      })
      .finally(() => {
        setButtonLoading(false);
      });

    await actionSignIn({
      account: user_name,
      passwd: password,
      trans_code: trans_code
    })
      .then((data) => {
        if (Cookies.get('token')) {
          Cookies.remove('token');
        }
        Cookies.set('token', data.token, { expires: 365 });
        Cookies.remove('trans_code');

        dispatch({
          type: 'INITIALIZE_API',
          navigate: navigate
        });

        navigate('/');
      })
      .finally(() => {
        setButtonLoading(false);
      });
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        clearInterval(interval);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  });

  return (
    <form className="max-w-[350px]" onSubmit={handleSubmit}>
      <VStack spacing={`15px`}>
        <FormControl
          display={'flex'}
          alignItems={'center'}
          pl="15px"
          gap="5px"
          isRequired
          bg="rgba(0, 0, 0, 0.4)"
          borderRadius="15px"
          border="1px solid"
          borderColor="cyan.400"
          boxShadow="0 0 8px cyan, 0 0 16px cyan, inset 0 0 6px rgba(0, 255, 255, 0.5)"
          _placeholder={{ color: 'cyan.300' }}
        >
          <Box>
            <Image
              minW="17px"
              minH="23px"
              maxW="17px"
              maxH="23px"
              src={`${COMMON_WEB_PATH}/theOne/signIn/account_icon.svg`}
            />
          </Box>
          <InputGroup w="100%" bgSize="100% 100%">
            <Input
              type="text"
              bg="transparent"
              name="user_name"
              value={user_name}
              onChange={handleInputChange}
              placeholder={i18n_formHint('includeSixEnglishAndNumber')}
              title={i18n_formHint('includeSixEnglishAndNumber')}
              pattern={accountExpressForInput}
              border="none"
              px="5px"
              _focus={{
                border: 'none',
                outline: 'none !important',
                boxShadow: 'none !important'
              }}
            />
          </InputGroup>
        </FormControl>
        <FormControl
          display={'flex'}
          alignItems={'center'}
          pl="15px"
          gap="5px"
          isRequired
          bg="rgba(0, 0, 0, 0.4)"
          borderRadius="15px"
          border="1px solid"
          borderColor="cyan.400"
          boxShadow="0 0 8px cyan, 0 0 16px cyan, inset 0 0 6px rgba(0, 255, 255, 0.5)"
          _placeholder={{ color: 'cyan.300' }}
        >
          <Box>
            <Image
              minW="17px"
              minH="23px"
              maxW="17px"
              maxH="23px"
              src={`${COMMON_WEB_PATH}/theOne/signIn/pwd_icon.svg`}
            />
          </Box>
          <InputGroup w="100%" bgSize="100% 100%">
            <Input
              type={showPassword ? 'text' : 'password'}
              bg="transparent"
              name="password"
              value={password}
              onChange={handleInputChange}
              placeholder={i18n_formHint('includeEightEnglishAndNumber')}
              title={i18n_formHint('includeEightEnglishAndNumber')}
              pattern={passwordExpressForInput}
              border="none"
              px="5px"
              _focus={{
                border: 'none',
                outline: 'none !important',
                boxShadow: 'none !important'
              }}
            />
            <InputRightElement top="unset" bottom="0px">
              {showPassword ? (
                <FaEyeSlash
                  className="cursor-pointer"
                  onClick={handleSeePassword}
                />
              ) : (
                <FaEye className="cursor-pointer" onClick={handleSeePassword} />
              )}
            </InputRightElement>
          </InputGroup>
        </FormControl>
        {trans_code && (
          <FormControl isRequired>
            <FormLabel>{i18n_common_form('轉移代碼')}</FormLabel>
            <InputGroup>
              <InputLeftElement pointerEvents="none">
                <BiTransferAlt className={iconStyle} />
              </InputLeftElement>
              <Input
                type={'text'}
                variant={`brandPrimary`}
                name="trans_code"
                value={trans_code}
                isDisabled={true}
              />
            </InputGroup>
          </FormControl>
        )}
        {unlimit_code && (
          <FormControl>
            <FormLabel>{i18n_common_form('refer_code')}</FormLabel>
            <InputGroup>
              <InputLeftElement pointerEvents="none">
                <FaUserFriends className={iconStyle} />
              </InputLeftElement>
              <Input
                type={`text`}
                variant={`brandPrimary`}
                name="unlimit_code"
                isDisabled={true}
                value={unlimit_code}
              />
            </InputGroup>
          </FormControl>
        )}{' '}
        {window?.email_verification == 1 ? (
          <Flex gap="10px" w="100%" alignItems={`flex-end`}>
            <FormControl isRequired>
              <FormLabel>{i18n_common_form('email')}</FormLabel>
              <InputGroup>
                <InputLeftElement pointerEvents="none">
                  <MdMail className={iconStyle} />
                </InputLeftElement>
                <Input
                  type="email"
                  variant={`brandPrimary`}
                  name="email"
                  value={email}
                  onChange={handleInputChange}
                  placeholder={`${i18n_common(
                    'pleaseInput'
                  )} ${i18n_common_form('email')}`}
                />
              </InputGroup>
            </FormControl>
            <Button
              type="button"
              onClick={() => {
                handleVerifyEmail();
              }}
              isDisabled={emailLoading || seconds > 0}
              isLoading={emailLoading}
            >
              {emailSendStatus ? seconds : i18n_formHint('verify')}
            </Button>
          </Flex>
        ) : null}
        {emailSendStatus && (
          <FormControl isRequired>
            <FormLabel>{i18n_formHint('verify_code')}</FormLabel>
            <InputGroup>
              <InputLeftElement pointerEvents="none">
                <CgPassword className={iconStyle} />
              </InputLeftElement>
              <Input
                type="text"
                variant={`brandPrimary`}
                name="code"
                value={code}
                onChange={handleInputChange}
              />
            </InputGroup>
          </FormControl>
        )}
        {/* {agent_name && (
          <FormControl>
            <FormLabel>{i18n_common_form("agent_refer_code")}</FormLabel>
            <InputGroup>
              <InputLeftElement pointerEvents="none">
                <FaUserFriends className={iconStyle} />
              </InputLeftElement>
              <Input
                type={`text`}
                variant={`brandPrimary`}
                name="agent_name"
                isDisabled={true}
                value={agent_name}
              />
            </InputGroup>
          </FormControl>
        )} */}
        {invite && (
          <Flex gap="10px" w="100%" mt="10px" justifyContent={`flex-start`}>
            <Text fontSize={`sm`} fontWeight={`semibold`} color="brand.500">
              {i18n_common_form('agent_refer_code')}：{invite}
            </Text>
          </Flex>
        )}
        <Flex
          justifyContent={'center'}
          alignItems={'center'}
          gap="5px"
          w="100%"
          position="absolute"
          bottom="-70px"
        >
          <Button
            sx={{
              bgImage: `url(${COMMON_WEB_PATH}/blue-layout/modal${i18next.language === 'tw' ? '' : `/${i18next.language}`}/register_button.png)`,
              bgSize: 'contain',
              bgRepeat: 'no-repeat',
              bgPosition: 'center',
              background: 'transparent',
              _hover: {
                bgImage: `url(${COMMON_WEB_PATH}/blue-layout/modal${i18next.language === 'tw' ? '' : `/${i18next.language}`}/register_button.png)`
              },
              _active: {
                bgImage: `url(${COMMON_WEB_PATH}/blue-layout/modal${i18next.language === 'tw' ? '' : `/${i18next.language}`}/register_button.png)`
              },
              h: '80px'
            }}
            isLoading={buttonLoading}
            disabled={buttonLoading}
            py="20px"
            type="submit"
            w="180px"
          ></Button>
          <Box
            sx={{
              bgImage: `url(${COMMON_WEB_PATH}/blue-layout/modal${i18next.language === 'tw' ? '' : `/${i18next.language}`}/cancel_button.png) !important`,
              bgSize: 'contain !important',
              bgRepeat: 'no-repeat !important',
              bgPosition: 'center !important',
              background: 'transparent',
              _hover: {
                bgImage: `url(${COMMON_WEB_PATH}/blue-layout/modal${i18next.language === 'tw' ? '' : `/${i18next.language}`}/cancel_button.png)`
              },
              _active: {
                bgImage: `url(${COMMON_WEB_PATH}/blue-layout/modal${i18next.language === 'tw' ? '' : `/${i18next.language}`}/cancel_button.png)`
              },
              h: '80px'
            }}
            isLoading={buttonLoading}
            disabled={buttonLoading}
            py="20px"
            as={Link}
            to="../signin"
            w="180px"
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
          ></Box>
          {/* <GoogleLoginButton
            setButtonLoading={setButtonLoading}
            buttonLoading={buttonLoading}
          /> */}
          {/* <GoogleLoginV2 />
          <TelegramLogin
            setButtonLoading={setButtonLoading}
            buttonLoading={buttonLoading}
          /> */}
        </Flex>
      </VStack>
    </form>
  );
};

export default SignupForm;
